// ---------------------------------------------------------------------------
// Formatadores BR da tela índice de Roteirizações (handoff 0036 §3).
// Convenções pt-BR: moeda R$ 8.120,00; data curta "22/06 · seg"; tempo
// relativo (agora/há N min/há N h/ontem/há N dias/DD/<mês>); período Manhã/Tarde.
// ---------------------------------------------------------------------------

const WEEKDAYS = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
const MONTHS = [
   'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
   'jul', 'ago', 'set', 'out', 'nov', 'dez',
];

function pad2(n) {
   return String(n).padStart(2, '0');
}

// "8120" → "R$ 8.120,00". Vírgula decimal, ponto de milhar, espaço após R$.
export function formatBRL(value) {
   const n = Number(value);
   if (Number.isNaN(n)) return '—';
   return `R$ ${n.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
   })}`;
}

// "2026-06-22" → "22/06 · seg". Date às 12:00 local evita drift de timezone.
export function formatDateShort(ymd) {
   if (!ymd) return '—';
   const d = new Date(`${ymd}T12:00:00`);
   if (Number.isNaN(d.getTime())) return '—';
   return `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)} · ${
      WEEKDAYS[d.getDay()]
   }`;
}

// 'MANHA' → 'Manhã' · 'TARDE' → 'Tarde'.
export function periodLabel(period) {
   if (period === 'MANHA') return 'Manhã';
   if (period === 'TARDE') return 'Tarde';
   return period ?? '—';
}

// ISO datetime (com offset -03:00) → "agora/há N min/há N h/ontem/há N dias/DD/mês".
export function formatRelative(iso) {
   if (!iso) return '—';
   const then = new Date(iso);
   if (Number.isNaN(then.getTime())) return '—';
   const diffMs = Date.now() - then.getTime();
   if (diffMs < 0) return 'agora';
   const min = Math.floor(diffMs / 60000);
   if (min < 1) return 'agora';
   if (min < 60) return `há ${min} min`;
   const hours = Math.floor(min / 60);
   if (hours < 24) return `há ${hours} h`;
   const days = Math.floor(hours / 24);
   if (days === 1) return 'ontem';
   if (days < 7) return `há ${days} dias`;
   return `${pad2(then.getDate())}/${MONTHS[then.getMonth()]}`;
}

// last_optimized_at → "Otimizada há 2 h" | "Nunca otimizada".
export function formatOptimized(lastOptimizedAt) {
   if (!lastOptimizedAt) return 'Nunca otimizada';
   return `Otimizada ${formatRelative(lastOptimizedAt)}`;
}
